import { useLocation } from "react-router";

import TertiaryButton from "@components/buttons/TertiaryButton";
import MessageTemplateCategoriesTable from "@components/MessageTemplateCategoriesTable";
import ExpertTablesPage from "@components/pageTypes/ExpertTablesPage";

const ExpertMessageTemplatesPage = () => {
  const location = useLocation();

  return (
    <ExpertTablesPage helmetKey="pageTitles.expert.messageTemplateCategory.list">
      <div className="banner">
        <TertiaryButton
          icon="chevronLeft"
          routerLink={`/expert/message-templates${location.search}`}
          textKey="dictionary.back"
        />
      </div>

      <MessageTemplateCategoriesTable />
    </ExpertTablesPage>
  );
};

export default ExpertMessageTemplatesPage;
